// @flow

export default {
  wizard: {
    next: 'Prossimo',
    back: 'Di ritorno',
    skip: 'Saltare',
    sort: 'Ordinare',
    sorting: {
      'utility:desc': 'Miglior risultato',
      'price:asc': 'Prezzo ascendente',
      'price:desc': 'Prezzo che scende',
      'created_at:desc': 'Più recente',
      'customer_rating:desc': 'Valutazione del cliente'
    },
    clickToAddFiles: 'Fai clic per aggiungere i tuoi file o rilasciali qui.',
    searchFor: 'Cercare ...',
    noSearchResults: 'Purtroppo non abbiamo trovato opzioni adatte. Si prega di cercare di nuovo.',
    loadMoreAnswerOptions: 'Nessuna opzione adatta qui? Visualizza tutte le opzioni.',
    noRecommendationDescription: 'Oh no, sfortunatamente non siamo riusciti a trovare prodotti che si adattano alle tue esigenze.',
    noRecommendationDescription2: 'Si prega di riavviare il consulente del prodotto.',
    noRecommendationRestartButtonTitle: 'Ricomincia',
    noRecommendationCloseButtonTitle: 'Vicino',
    removeFile: 'Rimuovi file'
  },
  chatbot: {
    selectAll: 'Seleziona tutto',
    none: 'Nessuno',
    confirmButton: 'Confermare',
    customerServiceInputPlaceholder: 'Scrivi un messaggio ...',
    you: 'Voi',
    restart: 'Ricominciare',
    close: 'Vicino',
    send: 'Inviare',
    supportChat: 'Chat di supporto',
    honeypot: 'Si prega di lasciare vuoto questo campo',
    scrollToTheLatestMessage: 'Scorri all\'ultimo messaggio',
    removeFile: 'Rimuovi file'
  },
  product: {
    loadMore: 'Carica più prodotti',
    badgeTitle: 'La nostra raccomandazione',
    ctaButtonTitle: 'Scopri il prodotto',
    matchingPanelTitle: 'Su misura per le tue esigenze',
    bestFit: 'Il più adatto',
    bestPrice: 'Miglior prezzo',
    bestFitForPrice: 'Miglior adattamento per il prezzo',
    addToCartError: 'Aggiungi al carrello non ha avuto successo. Per favore riprova',
    addRoutineToCart: 'Aggiungi routine al carrello',
    explanationHeader: 'Più informazioni sul prodotto:',
    emptyRoutineItem: 'Sfortunatamente non esiste un prodotto in quella categoria che corrisponda alle tue preferenze.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Product Advisor'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Sfortunatamente, questa opzione non porterebbe a nessun prodotto desiderato. Puoi modificare le tue preferenze nei passaggi precedenti per abilitare l\'opzione.'
  }
}
